<template>
  <div class="time-container" :class="{rt: departure.vehicleId, 'next-day': departure.nextDay, first: first}">
    <div v-if="departure.minutes == null || departure.minutes >= 60 || doNotAbbreviate">
      {{time.substr(0,5)}}
    </div>
    <div v-if="departure.minutes >= 1 && departure.minutes < 60  && !doNotAbbreviate">
      {{departure.minutes.toFixed(0)}} <span class="small">min</span>
    </div>
    <div v-if="departure.minutes < 1 && !doNotAbbreviate">
      Agora
    </div>
    <div class="sub" v-if="departure.nextDay">Amanhã</div>
    <div class="sub vehicle" v-if="departure.vehicleId && panelConfig.showVehicle">
      <svg height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h48v48h-48z" fill="none"/>
        <path d="M8 32c0 1.77.78 3.34 2 4.44v3.56c0 1.1.9 2 2 2h2c1.11 0 2-.9 2-2v-2h16v2c0 1.1.89 2 2 2h2c1.1 0 2-.9 2-2v-3.56c1.22-1.1 2-2.67 2-4.44v-20c0-7-7.16-8-16-8s-16 1-16 8v20zm7 2c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm18 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-12h-24v-10h24v10z"/>
      </svg>
      {{departure.vehicleId}}
    </div>
  </div>
</template>

<script>
import { timeToSeconds, secondsToTime } from '../utils';

export default {
  props: ['panelConfig', 'departure', 'first', 'doNotAbbreviate'],

  data() {
    return {
      time: null,
    }
  },

  created() {
    const timeInSeconds = timeToSeconds(this.departure?.time);

    // if bigger than 24 hours, remove 24 hours
    if (timeInSeconds > 86400) {
      this.time = secondsToTime(timeInSeconds - 86400);
    } else {
      this.time = this.departure.time;
    }
  }

}
</script>

<style lang="scss" scoped>
.time-container {
  font-size: 1.1em;
  text-align: center;

  &.first {
    font-weight: 600;
  }
}
.rt {
  color: #2D9434;
}
.next-day {
  opacity: .5;
}
.sub {
  font-size: .5em;

  &.vehicle {
    svg {
      width: 1em;
      height: 1em;
      vertical-align: bottom;
      margin: 0 -.1em .05em 0;

      path:nth-of-type(2) {
        fill: #2D9434;
      }
    }
  }
}
.small {
  font-size: .8em;
  margin-left: -.15em;
}

@media only screen and (min-width: 600px) {
  .time-container {
    width: 3.1em;
    display: inline-block;
  }
  .sub {
    font-size: .4em;
    position: absolute;
    margin: -.4em 2.1em;
  }
}
</style>
